import { useParams } from 'react-router-dom';
import { ReactElement, useEffect } from 'react';

import AllocationBreadcrumbs from '../AddClientAllocation/AllocationBreadcrumbs';
import { AddClientAllocationProvider } from '../AddClientAllocation/context/AddClientAllocationContext';
import { IParams } from '../EditClientAllocation/types';
import { useStoreActions } from '~/store/hooks';
import DuplicateClientAllocationForm from './DuplicateClientAllocationForm';
import useGetDuplicateClientAllocations from './hooks/useGetDuplicateClientAllocations';

const DuplicateClientAllocation = (): ReactElement => {
  const { actTeamId, clientAllocationDate } = useParams<IParams>();
  const { resetClientAllocationAvailability } = useStoreActions(
    actions => actions.clientAllocation,
  );
  const { allocations } = useGetDuplicateClientAllocations({
    actTeamId,
    clientAllocationDate,
    crisisAccess: false,
  });

  useEffect(() => {
    resetClientAllocationAvailability();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AddClientAllocationProvider>
      <AllocationBreadcrumbs />
      <DuplicateClientAllocationForm duplicateAllocation={allocations} />
    </AddClientAllocationProvider>
  );
};

export default DuplicateClientAllocation;
